<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="Change My Pro" back-route="support" /></div>
    </div>
    <BLoading :active.sync="isLoading" />
    <div class="columns">
      <div class="column is-6"><ChangeMyPro /></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { LsSupportHeader } from '../components';
import ChangeMyPro from './ChangeMyPro.vue';

export default {
  name: 'ChangeMyProviderView',
  components: {
    LsSupportHeader,
    ChangeMyPro,
  },
  data() {
    return {
      message: '',
    };
  },
  computed: {
    ...mapState(['support', 'properties']),
  },
};
</script>

<style lang="scss" scoped>
p:not(:last-child) {
  margin-bottom: 16px;
}

.main-content {
  margin-bottom: 30px;
  @media (max-width: $mobile-max-width) {
    margin-bottom: 60px;
  }
}
</style>
